'use client';
import { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { Menu, House, User, Star, MessageCircleQuestion } from 'lucide-react';

import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import LogoWhite from '@/components/icons/logo-white';

import MobileNavbarFooter from './mobile-navbar-footer';

const navLinks = [
  { label: 'Home', icon: <House size={24} />, href: '/' },
  { label: 'About Us', icon: <User size={24} />, href: '/about-us' },
  { label: 'Services', icon: <Star size={24} />, href: '/services' },
  { label: 'FAQs', icon: <MessageCircleQuestion size={24} />, href: '/faqs' },
];

const MobileNavbarSheet = () => {
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="max-w-[300px]">
      <Sheet open={isOpen} onOpenChange={handleToggle}>
        <SheetTrigger asChild>
          <Menu
            size={32}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                handleToggle();
              }
            }}
          />
        </SheetTrigger>
        <SheetContent
          className="w-[300px] rounded-bl-[1rem] rounded-tl-[1rem] bg-rm-secondary-100 p-10"
          aria-label="mobile menu"
        >
          <div className="mb-8 flex flex-col items-center gap-y-[30px] pt-4">
            {navLinks.map((link) => (
              <Link
                href={link.href}
                className="flex w-full items-center gap-x-4 px-3 text-white"
                key={link.label}
                onClick={handleToggle}
              >
                {link.icon}
                <span className="text-xl font-semibold md:text-2xl">
                  {link.label}
                </span>
              </Link>
            ))}
          </div>
          <SheetTitle aria-describedby="mobile-menu">
            {pathname.includes('/contact') ? (
              <Link
                href={'/services'}
                className="block w-full rounded-full bg-white p-3 text-center text-[1.1rem] text-rm-secondary-100"
                onClick={handleToggle}
              >
                Browse Services
              </Link>
            ) : (
              <Link
                href={'/contact-us'}
                className="block w-full rounded-full bg-white p-3 text-center text-[1.1rem] text-rm-secondary-100"
                onClick={handleToggle}
              >
                Get in Touch
              </Link>
            )}
            <SheetDescription />
          </SheetTitle>
          <SheetFooter className="my-10 flex-col">
            <LogoWhite className="mb-4 h-auto w-full" />
            <MobileNavbarFooter />
          </SheetFooter>
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default MobileNavbarSheet;
